'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = addCustomTags;

// @ngInject
function addCustomTags($document) {
  // IE8 check ->
  // https://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
  if ($document && $document.documentMode < 9) {
    (function () {
      var document = $document.get(0);
      // add the custom elements that we need for formly
      var customElements = ['formly-field', 'formly-form'];
      _angularFix2['default'].forEach(customElements, function (el) {
        document.createElement(el);
      });
    })();
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./run/formlyCustomTags.js
 **/